import React, { useEffect, useState } from 'react';
import styles from 'routes/vendorRe/pages/VendorStats.module.css';
import FlexChild from 'layouts/flex/FlexChild';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import { useParams } from 'react-router-dom';
import { requester } from 'App';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import P from 'components/P';
import VendorStoreModal from './commons/VendorStoreModal';

// 정산내역
// 해당 상점의 매출, 본사 기준에서 정산해야 할 돈, 본사의 순 이익

// 스타일 변수
const fontSize = 'max(1.4vw, 10px)';
const fontColor = '#B7B7B7';
const paddBottom = '0 0 1vw';
const paddTopBottom = '1vw 0';

const VendorStoreCalc = () => {
    const { storeNo } = useParams();

    const date = new Date();
    const currentYear = date.getFullYear();
    const currentMonth = date.toLocaleString('ko-KR', { month: 'long' });

    // 버튼 스타일 정의
    const [isHovered, setIsHovered] = useState(false);
    const buttonStyle = {
        backgroundColor: '#FE531F',
        padding: '0.5rem 0.8rem',
        borderRadius: '1rem',
        textAlign: 'center',
        cursor: 'pointer',
        transition: 'all 0.4s',
        // hover 상태일 때의 스타일
        ...(isHovered && {
            backgroundColor: '#cc4218',
            // 다른 hover 스타일 추가 가능
        }),
    };

    // 모달 기능
    const [show, setShow] = useState(false);

    const handleClickModal = e => {
        setShow(true);
    };
    const closeModal = () => {
        setShow(false);
    };

    return (
        <VerticalFlex>
            <FlexChild
                backgroundColor="white"
                padding="max(1vw, 10px)"
                borderRadius="1rem"
            >
                <VerticalFlex>
                    <FlexChild padding={paddBottom}>
                        <HorizontalFlex>
                            <FlexChild>
                                <P
                                    weight={700}
                                    size={fontSize}
                                    padding="0 1vh 0 0"
                                >
                                    정산 내역
                                </P>
                                <P size={'max(1vw, 8px)'} color={'#A4A4A4'}>
                                    ( {currentYear}년 {currentMonth} 기준 )
                                </P>
                            </FlexChild>
                        </HorizontalFlex>
                    </FlexChild>
                    <FlexChild>
                        <div className={styles.borderTop}>
                            <VerticalFlex>
                                <FlexChild
                                    padding={paddTopBottom}
                                    borderTop={'1px solid #D9D9D9'}
                                >
                                    <HorizontalFlex>
                                        <FlexChild flex="3">
                                            <P
                                                size={fontSize}
                                                color={fontColor}
                                            >
                                                푸푸 관저점 매출
                                            </P>
                                        </FlexChild>
                                        <FlexChild
                                            flex="1"
                                            justifyContent={'flex-end'}
                                        >
                                            <P
                                                weight={700}
                                                size={fontSize}
                                                color={fontColor}
                                            >
                                                0
                                            </P>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                <FlexChild padding={paddTopBottom}>
                                    <HorizontalFlex>
                                        <FlexChild flex="3">
                                            <P
                                                size={fontSize}
                                                color={fontColor}
                                            >
                                                본사 정산 금액
                                            </P>
                                        </FlexChild>
                                        <FlexChild
                                            flex="1"
                                            justifyContent={'flex-end'}
                                        >
                                            <P
                                                weight={700}
                                                size={fontSize}
                                                color={fontColor}
                                            >
                                                0
                                            </P>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                <FlexChild padding={paddTopBottom}>
                                    <HorizontalFlex>
                                        <FlexChild flex="3">
                                            <P size={fontSize} color={'#000'}>
                                                푸푸 관저점 순이익
                                            </P>
                                        </FlexChild>
                                        <FlexChild
                                            flex="1"
                                            justifyContent={'flex-end'}
                                        >
                                            <P
                                                weight={700}
                                                size={fontSize}
                                                color={'#FE531F'}
                                            >
                                                0
                                            </P>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                <FlexChild padding={paddTopBottom}>
                                    <HorizontalFlex>
                                        <FlexChild flex="3">
                                            <P size={fontSize} color={'#000'}>
                                                본사 순이익
                                            </P>
                                        </FlexChild>
                                        <FlexChild
                                            flex="1"
                                            justifyContent={'flex-end'}
                                        >
                                            <P
                                                weight={700}
                                                size={fontSize}
                                                color={'#FE531F'}
                                            >
                                                0
                                            </P>
                                        </FlexChild>
                                    </HorizontalFlex>
                                </FlexChild>
                                <FlexChild>
                                    <div
                                        style={buttonStyle}
                                        onMouseEnter={() => setIsHovered(true)}
                                        onMouseLeave={() => setIsHovered(false)}
                                        onClick={handleClickModal}
                                    >
                                        <P size={fontSize} color={'#fff'}>
                                            상세보기
                                        </P>
                                    </div>
                                    {/* 모달 처리 */}
                                    {show && (
                                        <VendorStoreModal
                                            callbackFn={closeModal}
                                        />
                                    )}
                                </FlexChild>
                            </VerticalFlex>
                        </div>
                    </FlexChild>
                </VerticalFlex>
            </FlexChild>
        </VerticalFlex>
    );
};

export default VendorStoreCalc;
